import {
    Button,
    TextField,
    MuiThemeProvider,
    createMuiTheme
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import { deleteBusinessArea, getBusinessAreaById, postBusinessArea, updateBusinessArea } from '../../../../api/businessArea'
import { alertError, alertSuccess } from '../../../../utils/logger'
import Editor from '../../../components/editor/Editor'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

// Create theme for delete button (red)
const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyText() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        description: {
            'es': "",
            'en': ""
        }
    }
}

export default function EditBusinessAreaPage() {
    const businessAreaId = useParams().id;
    const history = useHistory();
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton();

    const [businessArea, setBusinessArea] = useState(getEmptyText())
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);


    useEffect(() => {
        if (!businessAreaId) {
            disableLoadingData();
            return
        }

        getBusinessAreaById(businessAreaId).then(res => {
            setBusinessArea(res.data)
            disableLoadingData()
        }).catch(error => {
            alertError({ error: error, customMessage: 'Could not get business area.' })
            history.push('/businessArea')
        })
    }, [businessAreaId, disableLoadingData, history])

    function saveBusinessArea() {
        if (!businessAreaId) {
            postBusinessArea(businessArea)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Business area created successfully.",
                    });
                    history.push("/businessArea");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the business area.",
                    });
                });
        } else {
            updateBusinessArea(businessAreaId, businessArea).then(res => {
                alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
                history.push('/businessArea')
            }).catch(error => {
                alertError({ error: error, customMessage: 'Could not save changes.' })
            })
        }
    }

    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!businessArea[element])
                businessArea[element] = {}
            let newText = businessArea[element]
            newText[lang] = event.target.value
            setBusinessArea({ ...businessArea, [element]: newText })
        } else
            setBusinessArea({ ...businessArea, [element]: event.target.value })
    }

    const handleChangeEditor = (element, lang, value) => {
        if (lang) {
            if (value === ' ')
                return
            if (!businessArea[element])
                businessArea[element] = {}
            let newText = businessArea[element]
            newText[lang] = value
            setBusinessArea({ ...businessArea, [element]: newText })
        } else
            setBusinessArea({ ...businessArea, [element]: value })
    }


    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <TextField
                    label="Title"
                    value={(businessArea.title && businessArea.title[lang]) || ''}
                    onChange={handleChange('title', lang)}
                    margin="normal"
                    variant="outlined"
                    required
                />
                <Editor
                    body={(businessArea.description && businessArea.description[lang]) || ''}
                    setBody={new_body => handleChangeEditor('description', lang, new_body)}
                    className='max-height'
                    lang={lang}
                    placeholder={'Enter text content here...'}
                />
            </>
        )
    }

    if (isLoadingData)
        return <ContentSkeleton />

    return (
        <>
            <Card>
                <CardHeader title='Edit business area'>
                </CardHeader>
                <CardBody>
                    <MultilanguageTabBlock
                        multilanguageTabContent={renderMultilanguageTabContent}
                    />
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/businessArea')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Back
            </Button>
            <Button
                onClick={() => saveBusinessArea()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Save business area
            </Button>

            {businessAreaId && (
                <>
                    <MuiThemeProvider theme={theme}>
                        <Button
                            onClick={() => setOpenConfirmDialog(true)}
                            variant="outlined"
                            color="secondary"
                            style={{ marginRight: "20px" }}
                        >
                            Delete business area
                        </Button>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "auto",
                            }}
                        ></div>
                    </MuiThemeProvider>

                    <ConfirmDialog
                        title={"Are you sure you want to delete this business area?"}
                        open={openConfirmDialog}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteBusinessArea(businessAreaId)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Business area deleted successfully.",
                                    });
                                    history.push("/businessArea");
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the business area.",
                                    });
                                });
                        }}
                    />
                </>
            )}
        </>
    );
}